import * as React from "react";
import classnames from "classnames";
import get from "lodash/get";
import { QueryString, StringGuard, useEventListener } from "@grandvisionhq/utils";
/* empty css            */
const useResizeEventListener = (iframeId, iframeRef, setHeight, iframeHeight, initialHeight) => {
  const iframeEventHandler = React.useCallback(
    (e) => {
      if (initialHeight || !Array.isArray(e.data)) {
        return;
      }
      const [eventName, eventValue, eventIframeId] = e.data;
      if (iframeId !== eventIframeId) {
        return;
      }
      if (eventName === "setHeight" && iframeHeight !== eventValue) {
        setHeight(eventValue);
      } else if (eventName === "scrollTop" && iframeRef.current) {
        iframeRef.current.scrollIntoView();
        window.scrollBy(0, -100);
      }
    },
    [initialHeight, iframeHeight, iframeId, iframeRef]
  );
  useEventListener("message", iframeEventHandler);
};
const IFrame = ({
  source,
  title,
  height: initialHeight,
  scrolling,
  position = "center"
}) => {
  if (!source) {
    return null;
  }
  const [iframeHeight, setHeight] = React.useState(initialHeight);
  const iframeId = get(QueryString.parse(source.split("?")?.[1] ?? ""), "iframeId", "");
  const iframeRef = React.useRef(null);
  useResizeEventListener(
    StringGuard.guard("iframeId", iframeId),
    iframeRef,
    setHeight,
    iframeHeight,
    initialHeight
  );
  return /* @__PURE__ */ React.createElement("div", { className: "site-container" }, /* @__PURE__ */ React.createElement(
    "div",
    {
      className: classnames("iframe", {
        [`iframe--${position}`]: !!position
      })
    },
    /* @__PURE__ */ React.createElement(
      "iframe",
      {
        ref: iframeRef,
        frameBorder: "0",
        src: source,
        height: iframeHeight,
        scrolling: `${scrolling ? "yes" : "no"}`,
        title
      }
    )
  ));
};
export {
  IFrame as default
};
//# sourceMappingURL=Iframe.js.map
